import type { EndDirectorship, EndDirectorshipInput } from 'generated/gql';

export const mapEndDirectorshipToEndDirectorshipInput = (
  endDirectorship: Partial<EndDirectorship>,
): EndDirectorshipInput => ({
  directorshipId: endDirectorship.directorshipId || '',
});
